"use strict";

/**
 * Two banners on the right side of the video in desktop format
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  // refresh banners after new related videos loaded
  document.addEventListener('flix:additional-related', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled && FlixUtils.isDesktop() // desktop only
    && !!document.querySelector('#ads-ntv1'); // only on video page
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    FlixUtils.renderBannerAd(getZoneIdNtv1(), document.querySelector('#ads-ntv1'), 'eas6a97888e38', 'ad_error_ntv1');
    FlixUtils.renderBannerAd(getZoneIdNtv2(), document.querySelector('#ads-ntv2'), 'eas6a97888e38', 'ad_error_ntv2');
  }
  ;
  function getZoneIdNtv1() {
    return Flix.isTna() ? '4510376' : '4510408';
  }
  function getZoneIdNtv2() {
    return Flix.isTna() ? '4510388' : '4510414';
  }
})();